import React from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import { FaDownload } from 'react-icons/fa';

const CorporateIdentity = () => {
  return (
    <div className="corporate-identity-page">
      <div className="container py-5">
        <div className="row">
          <QuickMenu />
          
          <div className="col-md-10">
            <div className="corporate-identity-content">
              <h1 className="page-title">Kurumsal Kimlik</h1>
              
              <div className="identity-items">
                <div className="identity-item">
                  <div className="item-image">
                    <img src="/assets/images/logo.png" alt="İskenderun Belediyesi Logo" />
                  </div>
                  <div className="item-info">
                    <h3>Logomuz</h3>
                    <a href="/assets/images/logo.png" className="download-btn">
                      <FaDownload /> İndir
                    </a>
                  </div>
                </div>

                <div className="identity-item">
                  <div className="item-image">
                    <img src="/assets/images/iskenderun-kurumsal-kimlik.png" alt="Kurumsal Kimlik Kitapçığı" />
                  </div>
                  <div className="item-info">
                    <h3>Kurumsal Kimlik Kitapçığı</h3>
                    <a href="/assets/images/kurumsal-kimlik-kitapcik.pdf" className="download-btn">
                      <FaDownload /> İndir
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CorporateIdentity;
